import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { StockLabel } from './getAuthorizedStocksByUserIdQuery';

const ENDPOINT = `${APIConfiguration.sparePart}stocks/seller/${COMMON_QUERY_PARAMS.SELLER_ID}`;

export interface GetSparePartStocksBySellerQueryArgs {
  sellerId: string;
}

export default async function getSparePartStocksBySellerQuery(
  payload: GetSparePartStocksBySellerQueryArgs,
): Promise<BackResponse<StockLabel[]> | BackResponseFailure> {
  try {
    return await apiCall<BackResponse<StockLabel[]>>(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, payload.sellerId),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
